import {style} from 'typestyle'

export const recommendCategory = style({
    marginLeft: 15,
    marginRight: 15,
    borderRadius: 10,
    marginBottom: 15,
    marginTop: 20,
    display: 'block',
    background: '#fff',
    boxShadow: '0 2px 8px 0 #F0F0F0'
})

export const recommendCategoryTitle = style({
    position: 'relative',
    left: -5,
    top: -5,
    display: 'inline-block',
    padding: '9px 10px 9px 10px',
    fontSize: 18,
    color: '#FFFFFF',
    letterSpacing: 0,
    borderRadius: '10px 10px 0px 10px',
    lineHeight: '18px',
    fontWeight: 600
})

export const recommendCategoryDesc = style({
    fontSize: 14,
    marginTop: 5,
    color: '#999999',
    letterSpacing: 0,
    lineHeight: '20px',
    paddingLeft: 15,
    paddingRight: 15
})

export const recommendlectureContentArea = style({
    paddingTop: 7.5,
    paddingBottom: 7.5

})



// WEBPACK FOOTER //
// ./src/views/Category/components/CategoryRecommendPage/CategoryRecommendLectureModule/CategoryRecommendLectureModule.style.ts